export const PLAY = 'PLAY';
export const PAUSE = 'PAUSE';
export const SEEK = 'SEEK';
export const PREV_TRACK = 'PREV_TRACK';
export const NEXT_TRACK = 'NEXT_TRACK';
